import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Camera } from 'lucide-react';
const works = [{
  src: 'https://cdn.magicpatterns.com/uploads/ouQe8AHGmgLeXStNmnWehM/Screenshot_2026-06-08_at_12.23.06_PM.png',
  alt: 'Long auburn curls styled by Shazz',
  caption: 'Auburn Curls'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iGa1mHvdVU51o7MMtf1hY6/Screenshot_2026-06-08_at_12.23.15_PM.png',
  alt: 'Elegant braided updo styled by Shazz',
  caption: 'Elegant Braided Updo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/48hgfDGT5E5UoFGybY5t1D/Screenshot_2026-06-08_at_12.23.31_PM.png',
  alt: 'Glossy copper waves with dimensional color',
  caption: 'Copper Dimension'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aDnXKDev9EGvuTL48keph3/Screenshot_2026-06-08_at_12.27.55_PM.png',
  alt: 'Sleek high bun with swept bangs',
  caption: 'High Bun & Bangs'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hDYB9xCeAVCgv9oGxBJDtY/Screenshot_2026-06-08_at_12.29.08_PM.png',
  alt: 'Voluminous silver natural afro',
  caption: 'Silver Statement Afro'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/g9x2tZrWDhxcHsjm778o2n/Screenshot_2026-06-08_at_1.18.04_PM.png',
  alt: 'Long blonde knotless braids styled by Shazz',
  caption: 'Blonde Knotless Braids'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bjMtaKqr7z1KpXFjLyADi1/Screenshot_2026-06-08_at_1.18.31_PM.png',
  alt: 'Shazz with a client wearing long blonde braids',
  caption: 'Happy Client'
}];
export function Gallery() {
  return <section className="py-24 bg-white" data-id="element-159">
      <div className="container mx-auto px-6 md:px-12" data-id="element-160">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-161">
          <div className="max-w-2xl" data-id="element-162">
            <h2 className="text-brand-purple font-semibold tracking-widest uppercase text-sm mb-3" data-id="element-163">
              Portfolio
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-brand-dark" data-id="element-164">
              The Glamour Gallery
            </h3>
          </div>
          <p className="text-gray-500 italic font-serif" data-id="element-165">
            A glimpse of Shazz's signature work
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-166">
          {works.map((work, index) => <motion.figure key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative aspect-[4/5] overflow-hidden group bg-brand-light" data-id="element-167">
              <img src={work.src} alt={work.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-168" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-169" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-5 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300" data-id="element-170">
                <span className="text-white font-serif text-xl" data-id="element-171">
                  {work.caption}
                </span>
              </figcaption>
            </motion.figure>)}

          {/* Placeholder tile for future additions */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: works.length * 0.1
        }} className="aspect-[4/5] bg-brand-light/50 flex flex-col items-center justify-center text-brand-purple/40 border border-brand-purple/10 hover:bg-brand-light transition-colors group" data-id="element-172">
            <Camera className="w-12 h-12 mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-173" />
            <span className="font-serif text-lg" data-id="element-174">More looks coming soon</span>
          </motion.div>
        </div>
      </div>
    </section>;
}